var _path, _path2, _path3, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 11,
    viewBox: "0 0 33 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_889_34919",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 33,
    height: 11
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.131 9.57025C32.1278 10.278 31.519 10.8465 30.7684 10.8425C30.03 10.8385 29.4256 10.2605 29.4297 9.56239C29.4339 8.86134 30.0436 8.29584 30.7928 8.2981C31.5257 8.30031 32.134 8.87861 32.131 9.57025Z",
    fill: "#010101"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4518 6.59176L29.6868 6.27641C29.3707 4.38432 28.1901 3.30688 26.145 3.04409C23.0773 2.64991 21.181 3.99014 20.679 4.67339C20.177 5.35665 19.926 5.96107 19.8702 7.06478C19.8145 8.1685 20.5395 9.16711 20.7905 9.4299C21.0415 9.69269 22.1849 10.9804 25.0853 10.9804C27.9856 10.9804 28.9338 9.9292 29.4079 8.95688C29.5938 8.55394 29.6868 8.21231 29.6868 7.93199H26.5075C26.4146 8.72036 25.9405 9.11455 25.0853 9.11455C23.8024 9.11455 23.6351 7.98455 23.6909 7.06478C23.7466 6.14502 23.663 4.93618 25.0295 4.88362C25.9405 4.84859 26.4146 5.41796 26.4518 6.59176Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2246 8.63986V10.8043H14.4383V8.56554H15.5309V8.4989C15.5308 7.73809 15.531 6.97726 15.5303 6.21643C15.5301 5.99371 15.4777 5.78477 15.333 5.60339C15.1663 5.39426 14.9351 5.28444 14.669 5.23761C14.1877 5.15292 13.7373 5.22003 13.3431 5.50895C12.9835 5.7725 12.7973 6.12908 12.7894 6.55346C12.7771 7.21648 12.7863 7.87987 12.7865 8.54307C13.161 8.56233 13.5317 8.56233 13.9068 8.56233V10.8048H7.98966V8.5663H9.05378V5.20293H7.9893V2.9614H12.6576V4.50698C12.7271 4.43684 12.7826 4.38544 12.8326 4.32965C13.1951 3.925 13.6185 3.59375 14.1309 3.36933C14.4875 3.21316 14.8627 3.11813 15.2522 3.07369C15.9111 2.99853 16.5665 3.01244 17.2145 3.15779C17.6881 3.26403 18.1234 3.44599 18.4891 3.75763C18.8692 4.0816 19.0975 4.48735 19.1907 4.9573C19.2331 5.17097 19.2553 5.38776 19.2571 5.60513C19.2641 6.56111 19.2602 7.51716 19.2602 8.47322V8.56002H20.2246V8.63986ZM1.42407 2.95793H0.0117188V0.548828H7.58364V2.94411H6.17084V8.56065H7.58275V10.8035H0.0130853V8.56591H1.42407V2.95793Z",
    fill: "#010101"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_889_34919)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.0117188,
    y: 0.548828,
    width: 32.1845,
    height: 10.4315,
    fill: "#77838F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInc);
export default __webpack_public_path__ + "static/media/Inc.99f7bb7f3eb42d61d6f56f65fa28ad11.svg";
export { ForwardRef as ReactComponent };